export default __webpack_public_path__ + "static/media/horizon.d61d7639.png";